export default __webpack_public_path__ + "static/media/cssfront.3a9d09f7.svg";